<template>
  <CRow class="form-group kunden-auswahl-formgroup">
    <CCol sm="12">
      <label :class="formLabelClass">{{formLabel}}</label>
      <ValidationProvider :rules="rules" immediate v-slot="{ errors }">
        <v-select
          v-model="filterValue"
          ref="kundeselect"
          :options="paginated"
          placeholder="Bitte wählen Sie einen Kunden aus ..."
          :filterable="false"
          v-on:input="inputEvent"
          :class="isValidClass(errors)"
          :get-option-label="(option) => generateLabelName(option)"
          @search="onSearch"
        >
          <template #no-options>
            Keine Kunden gefunden.
          </template>
        </v-select>
      </ValidationProvider>
    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import MiniSearch from 'minisearch'

export default {
  name: 'KundenAuswahl',
  props: {
    value: [Object, Event],
    formLabel: {
      default: 'Kunden',
      type: String
    },
    formLabelClass: {
      default: 'd-none',
      type: String
    },
    rules: {
      default: 'required',
      type: String
    },
    deleteButton: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      index: null,
      isValid: false,
      filterValue: null,
      kundenDB: null,
      result: [],
      offset: 0,
      limit: 10,
      wait: false,
      miniSearch: null
    }
  },
  computed: {
    kunden () {
      return this.result
    },
    filtered () {
      return this.result.filter((kunde) =>
        kunde.toLocaleLowerCase().includes(this.search.toLocaleLowerCase())
      )
    },
    paginated () {
      return Array.isArray(this.result) ? this.result.slice(0, 150) : []
    }
  },
  async mounted () {
    this.loadKunden().then((response) => {
      this.miniSearch = new MiniSearch({
        idField: 'kundenid',
        fields: ['name1', 'strasse', 'hausnr', 'plz', 'ort'], // fields to index for full-text search
        storeFields: ['name1', 'name2', 'strasse', 'hausnr', 'plz', 'ort', 'kundenid'], // fields to return with search results
        searchOptions: {
          boost: { name1: 5, strasse: 3, ort: 3, hausnr: 2, plz: 3, kundenid: 0 },
          fuzzy: 0.1,
          wildcard: '*'
        }
      })
      this.miniSearch.addAll(this.kunden)
      this.valueToLocal()
      this.result = this.miniSearch.search('Hopster & Lambers Jacksonring 2')
      // const optionsKeys = this.optionsKeys
      // this.index = Fuse.createIndex(optionsKeys.keys, this.kundenDB)
    })
  },
  watch: {
    value: function () {
      this.valueToLocal()
    }
  },
  methods: {
    valueToLocal: function () {
      this.filterValue = this.value
      if (this.value) {
        this.isValid = true
      }
      // Value nach Kunde
      const self = this
      if (this.filterValue && this.kunden) {
        const arrayid = Vue._.findIndex(this.kunden, function (k) { return k.kundenid === self.filterValue })
        if (arrayid !== -1) {
          this.filterValue = this.kunden[arrayid]
        }
      }
    },
    onSearch (query) {
      this.search = query
      this.offset = 0
      const result = this.miniSearchQuery(this.kundenDB, query)
      this.result = result
    },
    inputEvent: function (newValue) {
      if (newValue) {
        this.isValid = true
        this.$emit('input', newValue)
      } else {
        // Null, bzw. delete-Button
        this.$emit('input', null)
      }
    },
    isValidClass: function (errors) {
      let result = 'form-control'
      if (errors.length === 0) {
        result = result + ' is-valid'
      } else {
        result = result + ' is-invalid'
      }
      return result
    },
    miniSearchQuery (options, search) {
      if (this.miniSearch != null) {
        const results = this.miniSearch.search(search, { prefix: true })

        if (results.length === 0) {
          const defaultResult = this.miniSearch.search('Hopster & Lambers')[0]
          const defaultNoResult = {
            name1: 'keine Ergebnisse gefunden',
            strasse: 'Bitte versuche es erneut.',
            hausnr: '',
            plz: '',
            ort: ''
          }

          if (defaultResult) {
            results.unshift(defaultResult)
            results.unshift(defaultNoResult)
          }
        }
        return results
      }
    },
    generateLabelName: function (kunde) {
      return kunde.name1 + '  |   ' + kunde.strasse + ' ' + kunde.hausnr + ' , ' + kunde.plz + ' ' + kunde.ort
    },
    generateStreet: function (kunde) {
      return kunde.name1 + '  |   ' + kunde.strasse + ' ' + kunde.hausnr + ' , ' + kunde.plz + ' ' + kunde.ort
    },
    loadKunden: function () {
      return Vue.axios.get('/kunden/getActive')
        .then((response) => {
          this.kundenDB = response.data
          this.result = this.kundenDB
        })
    }
  }
}
</script>

<style lang="scss">
div.kunden-auswahl-formgroup {
  div.form-control {
    padding: 1px 0 0 1px;
    div.vs__dropdown-toggle {
      border: none;
    }
  }
  div.v-select {
    height: auto;
  }
}

.vs__dropdown-menu{
  max-height: 90vh;
}
</style>
